import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Step01 from '../apply/form/Step01'
import Step02 from '../apply/form/Step02'
import Step03 from '../apply/form/Step03'
import Step04 from '../apply/form/Step04'
import Step05 from '../apply/form/Step05'
import PopGetItem from '../apply/form/PopGetItem'

import history from '../../../../route/history'
import { alertActions, certapplyActions, bundleActions } from '../../../../store/actions'

const BundleDetail = (props) => {
  const queryString = require('query-string')

  const [historyInfo, setHistoryInfo] = useState({})
  const [bundleInfo, setBundleInfo] = useState()

  let [paramKey, setParamKey] = useState()
  let [value, setValue] = useState()
  let [step, setStep] = useState(1)
  let [docid, setDocid] = useState()
  let [crtIssueSeq, setCrtIssueSeq] = useState()

  /**
   * 수정정보 조회
   */
  useEffect(() => {
    if (paramKey > 0) {
      if (props.totalData?.step1?.docid !== undefined) {
        setDocid(props.totalData?.step1?.docid)
      }
      setValue(paramKey)
      props.load(paramKey)
    }
  }, [step])

  const [packageNm, setPackageNm] = useState('')
  const [packageId, setPackageId] = useState('')
  const [packageCrtfNo, setPackageCrtfNo] = useState('')

  useEffect(() => {
    const locationInfo = props.location.state

    locationInfo &&
      setHistoryInfo({
        ...historyInfo,
        srhKeyword: locationInfo?.srhKeyword,
        pageIdx: locationInfo?.pageIdx || 0,
      })

    if (props.match.params.seq) {
      let packageId = props.match.params.seq
      props.getBundleInfo(packageId)
    }
  }, [])

  const goList = () => {
    let paramStr = queryString.stringify(historyInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/service/bundle' + paramStr)
  }

  useEffect(() => {
    if (props.bundleInfo) {
      let bundleInfo = props.bundleInfo
      Object.keys(bundleInfo).forEach((key) => {
        setPackageNm(bundleInfo[key]?.packageNm)
        setPackageId(bundleInfo[key]?.packageId)
        setPackageCrtfNo(bundleInfo[key]?.packageCrtfNo)
      })
      console.log('bundleInfo', bundleInfo)
      console.log('typeof bundleInfo', typeof bundleInfo)
      typeof bundleInfo !== 'object' && bundleInfo.map((item) => (item['toggle'] = false))
      setBundleInfo(bundleInfo)
    }
  }, [props.bundleInfo])

  let indexPlus

  const indexCount = (index) => {
    indexPlus = index + 1
    return indexPlus
  }

  const eventHandler = (e, index) => {
    e.preventDefault()
    const bundle = bundleInfo.map((item, idx) => (index === idx ? { ...item, toggle: !item.toggle } : item))
    setBundleInfo(bundle)
  }

  let styleOn = {
    display: 'block',
  }

  let styleOff = {
    display: 'none',
  }

  /**
   * 문서 삭제 콜백
   */
  useEffect(() => {
    if (props.isDelete === true) {
      sessionStorage.removeItem(value)
      window.location.replace('/service/bundle')
    }
  }, [props.isDelete])

  /**
   * 다음화면 진입을 위한 유효성 체크
   */
  const goStepNext = () => {
    onload(crtIssueSeq, parseInt(step) + 1)
  }

  /**
   * 이전화면 진입을 위한 유효성 체크
   */
  const goStepPrev = () => {
    onload(crtIssueSeq, parseInt(step) - 1)
  }

  /**
   * 문서 삭제처리
   */
  const doDelete = () => {
    props.confirm({
      title: '확인',
      message: '문서를 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteDoc(crtIssueSeq)
        },
      },
    })
  }

  const doIssue = (packageId, packageCrtfNo, senderId) => {
    console.log('packageId = ', packageId)
    console.log('packageCrtfNo = ', packageCrtfNo)
    console.log('senderId = ', senderId)
    props.confirm({
      title: '확인',
      message: '발급신청을 하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.issueDoc(crtIssueSeq, packageId, packageCrtfNo, senderId)
        },
      },
    })
  }

  const onload = (crtIssueSeq, step) => {
    setCrtIssueSeq(crtIssueSeq)
    setParamKey(crtIssueSeq)
    setStep(step)
  }

  return (
    <React.Fragment>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <h2>{packageNm}</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>꾸러미 신청</span>
            <em>꾸러미 신청 상세</em>
          </div>
        </div>

        <div className="request-wrap">
          {bundleInfo?.length > 0 ? (
            bundleInfo?.map((bundleObj, index) => {
              return (
                <div id="bundleInfo" key={index}>
                  <div className="toggle-tit">
                    <button
                      type="button"
                      onClick={(e) => eventHandler(e, index)}
                      className={bundleObj.toggle ? 'on' : ''}
                      aria-expanded={bundleObj.toggle ? 'true' : 'false'}
                      aria-controls={'sect-' + indexCount(index)}
                      aria-disabled={bundleObj.toggle ? 'true' : 'false'}
                    >
                      {bundleObj.crtNm}
                    </button>
                  </div>
                  {index === 0 && bundleObj.crtCd === '01' && (
                    <div
                      id={'sect-' + indexCount(index)}
                      className={bundleObj.toggle ? 'toggle-cont' : 'toggle-cont'}
                      style={bundleObj.toggle ? styleOn : styleOff}
                    >
                      <div className="steps-box">
                        <ul className="steps">
                          <li className={step === 1 ? 'on' : ''}>
                            <span className="num">1</span>일반정보
                          </li>
                          <li className={step === 2 ? 'on' : ''}>
                            <span className="num">2</span>구매물품
                          </li>
                          <li className={step === 3 ? 'on' : ''}>
                            <span className="num">3</span>수출근거 서류
                          </li>
                          <li className={step === 4 ? 'on' : ''}>
                            <span className="num">4</span>세금계산서
                          </li>
                          <li className={step === 5 ? 'on' : ''}>
                            <span className="num">5</span>발급신청
                          </li>
                        </ul>
                      </div>
                      {step === 1 && (
                        <Step01
                          packageId={packageId}
                          packageCrtfNo={packageCrtfNo}
                          passData={props.totalData}
                          search={props.location?.search}
                          onload={onload}
                          doDelete={doDelete}
                        />
                      )}
                      {step === 2 && (
                        <Step02
                          packageId={packageId}
                          packageCrtfNo={packageCrtfNo}
                          passData={props.totalData}
                          search={props.location?.search}
                          doDelete={doDelete}
                          goStepNext={goStepNext}
                          goStepPrev={goStepPrev}
                        />
                      )}
                      {step === 3 && (
                        <Step03
                          packageId={packageId}
                          packageCrtfNo={packageCrtfNo}
                          passData={props.totalData}
                          search={props.location?.search}
                          doDelete={doDelete}
                          goStepNext={goStepNext}
                          goStepPrev={goStepPrev}
                        />
                      )}
                      {step === 4 && (
                        <Step04
                          packageId={packageId}
                          packageCrtfNo={docid}
                          passData={props.totalData}
                          search={props.location?.search}
                          doDelete={doDelete}
                          goStepNext={goStepNext}
                          goStepPrev={goStepPrev}
                        />
                      )}
                      {step === 5 && (
                        <Step05
                          packageId={packageId}
                          packageCrtfNo={packageCrtfNo}
                          passData={props.totalData}
                          search={props.location?.search}
                          doDelete={doDelete}
                          doIssue={doIssue}
                          goStepPrev={goStepPrev}
                        />
                      )}
                      {props.isShowItems === true && <PopGetItem packageId={packageId} packageCrtfNo={crtIssueSeq} docid={docid} />}
                    </div>
                  )}
                </div>
              )
            })
          ) : (
            <div className="toggle-tit nodata">조회 결과가 없습니다.</div>
          )}
        </div>

        <div className="btn-block center mt40">
          <a href="#" className="btn-secondary lg w200" onClick={goList}>
            목록
          </a>
        </div>
      </div>
      {/* //contents */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    totalData: state.certapply.data,
    bundleInfo: state.bundle?.bundleInfo,
    isShowItems: state.certapply.isShowItems,
    isDelete: state.certapply.isDelete,
    isSend: state.certapply.isSend,
  }
}

const actionCreators = {
  getBundleInfo: bundleActions.getBundleInfo,
  success: alertActions.success,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteDoc: certapplyActions.deleteTempDoc,
  issueDoc: certapplyActions.issueDoc,
  load: certapplyActions.load,
}

export default connect(mapStateToProps, actionCreators)(BundleDetail)
